import script from "./ColorPickerPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorPickerPopover.vue?vue&type=script&setup=true&lang=ts"

import "./ColorPickerPopover.vue?vue&type=style&index=0&id=17c9c5ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c9c5ef"]])

export default __exports__